module.exports = __webpack_public_path__ + "img/lateraltext-sm.dba060ca.png";